import {observer} from 'mobx-react-lite'
import React, {useEffect, useLayoutEffect, useState} from 'react'
import {Lang} from 'yougile-lang'
import {boardSettingsStore} from '@components/board/board-settings/board-settings-store'
import {LinkButtonNew} from '@components/common/base/buttons'
import {ActionsPanel} from '@components/common/base/buttons/actions-panel/actions-panel'
import {Icon} from '@components/common/base/icon'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {StickerSettingsContent} from '@components/sticker/my-stickers/board-stickers/sticker-settings/sticker-settings-content'
import {TwTitle} from '@components/sticker/my-stickers/containers'
import {
  NewStickerType,
  useMyStickersStore
} from '@components/sticker/my-stickers/my-stickers-store'
import {getStickerIconByNewStickerType} from '@components/sticker/my-stickers/my-stickers-utils'
import {NumericStates} from '@components/sticker/my-stickers/sticker-editor/numeric-states'
import {SprintStates} from '@components/sticker/my-stickers/sticker-editor/sprint-states/sprint-states'
import {
  StickerEditorContext,
  StickerEditorStore,
  useStickerEditorStore
} from '@components/sticker/my-stickers/sticker-editor/sticker-editor-store'
import {StickerName} from '@components/sticker/my-stickers/sticker-editor/sticker-name'
import {StringStates} from '@components/sticker/my-stickers/sticker-editor/string-states'
import {TextStates} from '@components/sticker/my-stickers/sticker-editor/text-states'

const CreatingStickerBase = observer(() => {
  const [state, store] = useStickerEditorStore()

  const edited = store.edited
  useLayoutEffect(() => {
    store.checkEdited()
  }, [edited])

  if (!state.sticker) {
    return null
  }

  return (
    <div className="relative flex flex-col h-full">
      <WithPerfectScrollbar className="relative pb-[80px] h-full flex flex-col gap-8 pr-16 -mr-16">
        <TwTitle className="pb-16">
          <LinkButtonNew
            icon="IconArrowLeft"
            title={Lang.msg.back}
            onClick={store.tryGoBack}
          />
        </TwTitle>

        <div className="flex flex-col">
          <div className="py-8 flex gap-4 items-center text-sm-semibold text-primary">
            <Icon
              icon={getStickerIconByNewStickerType(state.stickerType)}
              color="secondary"
            />
            {Lang.msg.myStickers.creatingStickerType(state.stickerType)}
          </div>
          <StickerName />
        </div>

        {state.stickerType === 'string' && <StringStates />}
        {state.stickerType === 'sprint' && <SprintStates />}
        {state.stickerType === 'text' && <TextStates />}
        {state.stickerType === 'numeric' && <NumericStates />}

        <StickerSettingsContent />
      </WithPerfectScrollbar>

      <ActionsPanel
        className="!bottom-8"
        show={edited}
        primaryClick={store.trySave}
        primaryText={Lang.msg.create}
        secondaryText={Lang.msg.cancel}
        secondaryClick={store.cancel}
        error={store.hasErrors}
        errorText={store.errorText}
        errorBg={state.errorBg}
      />
    </div>
  )
})

export const CreatingSticker = observer(() => {
  const [, stickersStore] = useMyStickersStore()
  const [store] = useState(() => {
    const store = new StickerEditorStore(stickersStore, boardSettingsStore)
    const newStickerType = stickersStore.state.newStickerType as NewStickerType
    store.initForNewSticker(newStickerType)
    return store
  })

  useEffect(() => store.reset, [store])

  return (
    <StickerEditorContext.Provider value={store}>
      <CreatingStickerBase />
    </StickerEditorContext.Provider>
  )
})
